// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6GrXX","container":"styles_container__j0jh1","desc":"styles_desc__QaDPH","name":"styles_name__WAHui","dept":"styles_dept__HEGXO","img":"styles_img__lhhPd"};